import React from 'react';
import ContentHeader from "../../../layouts/shared/headers/ContentHeader";
import MenuItem from "@mui/material/MenuItem";
import styled from "@emotion/styled";
import Typography from "@mui/material/Typography";
import {useDispatch, useSelector} from "react-redux";
import {useAppMutation} from "../../../services";
import authServices from "../../../services/auth-services";
import {reloadUser} from "../../../redux/actions";
import teacherServices from "../../../services/teacher-services";
import {Formik} from "formik";
import DDImageField from "../../../component/DDImageField";
import commonServices from "../../../services/common-services";
import {useProfileContext} from "./context";
import Stack from "@mui/material/Stack";
import {Alert} from "@mui/material";
import {useTranslation} from "react-i18next";


const StyledMenuItem = styled(MenuItem)(({theme}) => ({
    padding: theme.spacing(0, 1),

    '&:hover': {
        backgroundColor: 'transparent',
    },

    '& .MuiTouchRipple-root': {
        display: 'none'
    }

}));

const Item = styled("div")({
    textAlign: 'center',
});


const Header = () => {

    const {globalState, setGlobalState} = useProfileContext();

    const dispatch = useDispatch();
    const {
        authUser
    } = useSelector(state => state.auth);
    const {mutate: saveImage, isError, data, isSuccess, isLoading} = useAppMutation(teacherServices.saveProfileImage);
    const [values, setValues] = React.useState({newImage: (authUser.images?.length > 0 ? authUser.images[0] : '')});
    const [errMsg, setErrMsg] = React.useState('');
    const [disableImageField, setDisableImageField] = React.useState(true)
    const {t} = useTranslation();
    React.useEffect(() => {

        if (isSuccess && data) {
            setValues({})
            console.log(data);
            const user = {...authServices.getAuthUser(), ...data}
            console.log('Profile-------------->', user);
            setValues({...values, newImage: data.images?.length > 0 ? data.images[0] : ''});
            authServices.updateAuthUser(user);
            dispatch(reloadUser());

        }
        else if (isError) {
            setErrMsg(t("common.sizeErr"));
            setTimeout(() => {
                setErrMsg("");
            }, 5000);
        }


    }, [isSuccess, data, isError])


    const handleFileSelection = async (file) => {
        if (disableImageField) return; // Return early if image field is disabled
        let b = await fetch(file).then(r => r.blob());
        if (b.size > 1000000) {
            setErrMsg(t("common.sizeErr"));
            setTimeout(() => {
                setErrMsg("");
            }, 4000);
            return
        }
        saveImage(await commonServices.blobToBase64(b));
    };


    return (
        <ContentHeader
            avatar={
                <><Formik initialValues={values} onSubmit={() => {
                }}>
                    <DDImageField
                        name={"profile_pic"}
                        alt={"user profile pic"}
                        path={values.newImage}
                        disabled={true}
                        onFileSelection={handleFileSelection}
                        sx={{width: 60, height: 60, margin: '0 auto 5px'}}
                    />
                </Formik>
                </>
            }
            title={globalState.profile?.firstName + ' ' + globalState.profile?.lastName}
            subheader={<Typography fontSize={12} variant={'body1'} color={'inherit'} mt={.2}>{errMsg}</Typography>}

            sx={{
                position: 'relative',
                zIndex: 1,

                '& .MuiCardHeader-action': {
                    alignSelf: 'center'
                }
            }}

        />
    );
};

export default Header;
